import React, { forwardRef } from 'react'

import { Box, BoxProps } from '../Box'
import { useFormControl } from '../../hooks/useFormControl'

export const RequiredIndicator = (props: BoxProps) => {
  return <Box as="span" ml={1} color="red.500" aria-hidden="true" children="*" {...props} />
}

///////////////////////////////////////////////////////////////////////////////////////////////

export interface FormLabelProps extends BoxProps, Omit<React.LabelHTMLAttributes<any>, 'color'> {
  isInvalid?: boolean
  /**
   * This prop is read from the `FormControl` context but can be passed as well.
   * If passed, it'll override the context and give the `label` look disabled
   */
  isDisabled?: boolean
  children: React.ReactNode
  isRequired?: boolean
}

export const FormLabel = forwardRef(({ children, isRequired, ...props }: FormLabelProps, ref) => {
  const formControl = useFormControl(props)

  return (
    <Box
      ref={ref}
      fontSize="md"
      textTransform="uppercase"
      pr="12px"
      pb="4px"
      opacity={formControl.isDisabled ? 0.4 : 1}
      fontWeight="bold"
      textAlign="left"
      verticalAlign="middle"
      fontFamily="heading"
      display="inline-block"
      as="label"
      color="gray.600"
      {...props}
    >
      {children}
      {(formControl.isRequired || isRequired) && <RequiredIndicator />}
    </Box>
  )
})

FormLabel.displayName = 'FormLabel'

export default FormLabel
